<!-- <div class="test-sticky"></div> -->

<div *ngIf="showSticky && !!user.id" class="sticky" [ngClass]="{ 'playerStyle': innerPlayer,
    'hasNew': (unreadNotificationMsgs + unreadSocketMsgs) > 0 && !showChatLog,
    'afterShow': showChatLog }">
    <div class="sticky-notification" (click)="toggleStickyChatLog()" [style.background-image]="'url(' + (stickyBg|absUrl) + ')'">
        <div class="notification-nums-ctn notranslate" *ngIf="(unreadNotificationMsgs + unreadSocketMsgs) > 0">{{ unreadNotificationMsgs + unreadSocketMsgs }}</div>
        <div class="sticky-close" (click)="closeSticky($event)">
            <i class="iconfont iconguanbi close"></i>
        </div>
    </div>
    <div class="sticky-chat" *ngIf="showChatLog">
        <app-chat-layout [partner]="partner" [showSidebar]="true" [fromSticky]="true" (onCloseChatLog)="onCloseChatLog()"></app-chat-layout>
    </div>
</div>